import React, {Component} from 'react'
import {injectIntl} from 'react-intl'
import ShopifyPosSignIn from './shopifypossignin.component.jsx';
import ContactValidationComponent from './contactvalidation.component.jsx';
import ReceivePayment from './receivePayment.component.jsx';

const queryString = require('query-string')

class ReceivePaymentComponent extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {}
    }

    render() {
        return <ShopifyPosSignIn
            uri={queryString.parse(this.props.location.search)}
            redirect="/p/embed/shopify/receive-payment">
            <ContactValidationComponent>
                <ReceivePayment/>
            </ContactValidationComponent>
        </ShopifyPosSignIn>
    }

}

export default injectIntl(ReceivePaymentComponent);


// WEBPACK FOOTER //
// ./src/embed/shopify/receivepaymentcontroller.component.jsx